import React from "react";
import useTranslate from "../truebar/contexts/Translate/TranslateContext";
import { Languages } from "../truebar/contexts/Translate/types";
import DownloadSection, { IVersions } from "../DownloadSection";

const PRIVACY_POLICY_FILE_PATH_PREFIX = "./files/privacy_policy/"
const versions: IVersions[] = [
    {
        englishFileName: 'PRIVACY POLICY_v1.2.pdf',
        slovenianFileName: 'POLITIKA ZASEBNOSTI_v1.2.pdf'
    },
    {
        englishFileName: 'PRIVACY POLICY_v1.1.pdf',
        slovenianFileName: 'POLITIKA ZASEBNOSTI_v1.1.pdf'
    }
]

const PrivacyPolicy = () => {

    const {
        selectedLanguage,
        changeLanguage
    } = useTranslate()

    const currentVersionFileName = selectedLanguage === Languages.si ? versions[0].slovenianFileName : versions[0].englishFileName

    return (
        <>
            <div style={{ float: 'right', paddingTop: '2vh', paddingRight: '5vw' }}>
                <button style={{ color: 'white' }} onClick={() => changeLanguage()}>
                    {selectedLanguage === Languages.si ? 'EN' : 'SI'}
                </button>
            </div>

            <div style={{ padding: '0 10vw' }}>
                <h1 style={{ textAlign: 'center', margin: '5vh 0' }}>{selectedLanguage === Languages.si ? 'Politika zasebnosti' : 'Privacy policy'}</h1>
                <h2 style={{ margin: '10vh 0 5vh 0' }}>{selectedLanguage === Languages.si ? 'Trenutna verzija' : 'Current version'}</h2>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <DownloadSection versionName={currentVersionFileName} filePathPrefix={PRIVACY_POLICY_FILE_PATH_PREFIX} />
                </div>

                {versions.length > 1 && (
                    <>
                        <h2 style={{ margin: '10vh 0 5vh 0' }}>{selectedLanguage === Languages.si ? 'Zgodovin verzij' : 'Version history'}</h2>
                        {versions.slice(1).map(version => {
                            const historyVersionFileName = selectedLanguage === Languages.si ? version.slovenianFileName : version.englishFileName
                            return <DownloadSection versionName={historyVersionFileName} filePathPrefix={PRIVACY_POLICY_FILE_PATH_PREFIX} />
                        })}
                    </>
                )}
            </div>
        </>
    )

}

export default PrivacyPolicy;


